import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9706aee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Treatment Considerations", -1))
const _hoisted_3 = { class: "treatment-details" }
const _hoisted_4 = { class: "op-button" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pre-Operative", -1))
const _hoisted_6 = {
  key: 0,
  class: "spacer"
}
const _hoisted_7 = {
  key: 0,
  class: "collapsibleDiv"
}
const _hoisted_8 = { class: "op-button" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Operative", -1))
const _hoisted_10 = {
  key: 0,
  class: "spacer"
}
const _hoisted_11 = {
  key: 0,
  class: "collapsibleDiv"
}
const _hoisted_12 = { class: "op-button" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Post-Operative", -1))
const _hoisted_14 = {
  key: 0,
  class: "collapsibleDiv"
}
const _hoisted_15 = { class: "bottom-nav" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " keyboard_double_arrow_left ", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Conditions")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

import ConditionLayout from '@/components/ConditionLayout.vue';
import { computed, ref } from 'vue';
import { useDefaultStore } from '@/store';
import { useRouter } from 'vue-router';
import { ConditionsTemplateModel } from "@/types"
import CollapseButton from '@/components/CollapseButton.vue';
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useDefaultStore()
  const router= useRouter()
  const getSelectedConditions = computed(() => store.getSelectedTopics)
  const showTreatment = ref([''])
  const changeTreatment = (treatment: string) => {
    const ind = showTreatment.value.indexOf(treatment)
    if (ind == -1) {
      showTreatment.value.push(treatment)
    } else {
      showTreatment.value.splice(ind, 1)
    }
  }
  const checkCondition = (treatment:string) => showTreatment.value.includes(treatment)
  const getCondition = (treatment: string, condition: string) => {
      const templates :ConditionsTemplateModel[] = store.getConditionsTemplate
      const template =  templates.find(l => l.condition === condition.toLowerCase() && l.treatment === treatment.toLowerCase())!
      return template
  }

  const goConditions = () => router.push('/Conditions')




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("span", _hoisted_4, [
            _hoisted_5,
            _createVNode(CollapseButton, {
              open: checkCondition('preop'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTreatment('preop')))
            }, null, 8, ["open"])
          ]),
          (!checkCondition('preop'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : _createCommentVNode("", true),
          _createVNode(_Transition, { name: "collapse" }, {
            default: _withCtx(() => [
              (checkCondition('preop'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectedConditions), (cnd) => {
                      return (_openBlock(), _createBlock(ConditionLayout, {
                        key: cnd + 'preop',
                        condition: cnd,
                        treatment: getCondition('preop', cnd)
                      }, null, 8, ["condition", "treatment"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("span", _hoisted_8, [
            _hoisted_9,
            _createVNode(CollapseButton, {
              open: checkCondition('op'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTreatment('op')))
            }, null, 8, ["open"])
          ]),
          (!checkCondition('op'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10))
            : _createCommentVNode("", true),
          _createVNode(_Transition, { name: "collapse" }, {
            default: _withCtx(() => [
              (checkCondition('op'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectedConditions), (cnd) => {
                      return (_openBlock(), _createBlock(ConditionLayout, {
                        key: cnd + 'op',
                        condition: cnd,
                        treatment: getCondition('op', cnd)
                      }, null, 8, ["condition", "treatment"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("span", _hoisted_12, [
            _hoisted_13,
            _createVNode(CollapseButton, {
              open: checkCondition('postop'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTreatment('postop')))
            }, null, 8, ["open"])
          ]),
          _createVNode(_Transition, { name: "collapse" }, {
            default: _withCtx(() => [
              (checkCondition('postop'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectedConditions), (cnd) => {
                      return (_openBlock(), _createBlock(ConditionLayout, {
                        key: cnd + 'postop',
                        condition: cnd,
                        treatment: getCondition('postop', cnd)
                      }, null, 8, ["condition", "treatment"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        class: "nav-button",
        type: "button",
        onClick: _withModifiers(goConditions, ["prevent"])
      }, _hoisted_19, 8, _hoisted_16)
    ])
  ]))
}
}

})